// extracted by mini-css-extract-plugin
module.exports = {"childWrapper":"Layout-module--childWrapper--2VRmm","cookieConsent":"Layout-module--cookieConsent--2eoBh"};